import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

export const useResponsiveBreakpoints = () => {
    const theme = useTheme();

    const isPdfExport =
        typeof window !== "undefined" && new URLSearchParams(window.location.search).get("__pdf") === "1";

    // Utilisation des breakpoints standards MUI
    const isExtraSmall = useMediaQuery(theme.breakpoints.down("sm"));
    const isMobile = useMediaQuery(theme.breakpoints.down("md")); // < 900px
    const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg")); // 900px - 1199px
    const isDesktop = useMediaQuery(theme.breakpoints.between("lg", "xl")); // 1200px - 1535px
    const isUltrawide = useMediaQuery(theme.breakpoints.up("xl")); // >= 1536px

    if (isPdfExport) {
        return {
            isMobile: false,
            isTablet: false,
            isDesktop: true,
            isUltrawide: false,
        };
    }

    return {
        isExtraSmall,
        isMobile,
        isTablet,
        isDesktop,
        isUltrawide,
    };
};

export const useResponsivePadding = () => {
    const { isMobile, isTablet, isDesktop, isUltrawide } = useResponsiveBreakpoints();

    if (isMobile) return "0.5rem"; // 8px
    if (isTablet) return "1.5rem"; // 24px
    if (isDesktop) return "2rem"; // 32px
    if (isUltrawide) return "2.5rem"; // 40px
    return "2rem"; // fallback
};
